/* eslint-disable */

var PageTemplate = {
  data() {
    return {
      isInitiailized: false,
      activeSubpage: "",
      params: {},
      subItemsList: [],
      subItemIndex: 0,
      subItemsLoaded: false,
      subPageSubItemLists: {},
      overrideAuthCallbacks: false
    }
  },
  props: ['subModals'],
  methods: {
    eventSubItemsLoaded() {
      this.subItemsLoaded = true;
      this.$emit('event-sub-items-loaded')
      this.updateUrl();
    },
    eventSubItemsChange(new_sub_items_list) {
      if (!new_sub_items_list) {
        return;
      }
      this.subItemsList = JSON.parse(JSON.stringify(new_sub_items_list));
      this.subPageSubItemLists[this.activeSubpage] = JSON.parse(JSON.stringify(new_sub_items_list));
      this.updateUrl();
    },
    eventParamsChange(new_params) {
      for (var key in new_params) {
        if (new_params[key] === null) {
          delete new_params[key];
        }
      }
      this.params = new_params;
      this.updateUrl();
    },
    selectSubpage(tabId) {
      this.activeSubpage = tabId;
      if (tabId in this.subPageSubItemLists === false) {
        this.subPageSubItemLists[tabId] = [tabId];
      }
      var new_sub_items_list = JSON.parse(JSON.stringify(this.subPageSubItemLists[tabId]));
      new_sub_items_list[this.subItemIndex] = tabId;

      this.eventSubItemsChange(new_sub_items_list)
    },
    restoresubModals() {
      if (!this.subModals) {
        this.selectSubpage(this.defaultSubpage)
        return;
      }
      var new_sub_items_list = this.subModals.split('~')
      //the last entry will be an empty one
      new_sub_items_list.pop()
      this.subItemsList = new_sub_items_list

      if (this.subItemsList.length > this.subItemIndex) {
        this.subPageSubItemLists[this.subItemsList[this.subItemIndex]] = this.subItemsList;
        this.selectSubpage(this.subItemsList[this.subItemIndex])
      }
      if (this.subItemsList.length === this.subItemIndex - 1) {
        this.eventSubItemsLoaded()
      }
    },
    updateUrl() {
      if (!this.subItemsLoaded || this.dontRebuildUrlOnchange) {
        return;
      }
      var modals = ""
      var params_string = ""
      var query = Object.assign({}, this.$route.query);
      for (var index in this.subItemsList) {
        if (typeof this.subItemsList[index] !== 'string' || this.subItemsList[index].length === 0) {
          continue;
        }
        modals += this.subItemsList[index] + '~'
      }

      var params_array = [];
      for (var key in this.params) {
        if (this.params[key] === null) {
          continue;
        }
        params_array.push(key);
      }
      params_array.sort();
      for (index in params_array) {
        var param_name = params_array[index].split('-')[1];
        params_string += '/' + param_name + '/' + this.params[params_array[index]]
      }

      var path = this.baseUrl + "/" + modals + params_string
      if (this.$route.path !== path) {
        this.$router.push({ path: path, query: query});
      }
    },
    waitWatchdogReady() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (window.G_vue_instance.$data.webGui.watchdogDbConnected === true) {
        this.isInitiailized = true;
        if (this.waitWatchdogReadyCallback) {
          this.waitWatchdogReadyCallback();
        }
      } else {
        setTimeout(this.waitWatchdogReady, 200);
      }
    },
    signingInFeedback() {
      let notification = "Verifying account.";
      this.$store.commit("updateNotifications", notification);
      this.$awn.info(notification);
    },
    signedInFeedback() {
      let notification = " Account Verified.";
      this.$store.commit("updateNotifications", notification);
      this.$awn.info(notification);
    },
    signInFailedFeedback(error) {
      localStorage.clear();
      localStorage.removeItem('vuex');
      location.assign(window.location.origin + '/login');
    },
    login() {
      localStorage.clear();
      localStorage.removeItem('vuex');
      location.assign(window.location.origin + '/login');
    },
    logout() {
      window.G_firebase_auth.bi5SignOut()
    },
  },
  watch: {
    subItemsList() {
      var submodalsValue = JSON.parse(JSON.stringify(this.subItemsList.filter(x => x)));
      var cachedSubmodalsValue = JSON.parse(JSON.stringify(this.subItemsList.filter(x => x)));
      cachedSubmodalsValue.pop();

      var submodalsAsString = JSON.stringify(submodalsValue);
      var lastSelectedSubmodal = window.G_vue_instance.$data.selectedSubModals[window.G_vue_instance.$data.selectedSubModals.length - 1];
      if (!lastSelectedSubmodal) {
        window.G_vue_instance.$data.selectedSubModals.push(submodalsValue);
        return;
      }
      var lastSelectedSubmodalAsString = JSON.stringify(lastSelectedSubmodal);

      if (submodalsAsString === lastSelectedSubmodalAsString) {
        return;
      } else if (
        submodalsValue[submodalsValue.length -1] === 'default' && 
        JSON.stringify(cachedSubmodalsValue) === lastSelectedSubmodalAsString
      ) {
        lastSelectedSubmodal.push('default');
        return;
      } else {
        window.G_vue_instance.$data.selectedSubModals.push(submodalsValue);
      }
    },
    '$root.backForwardUrlRequest': {
      handler() {

        var selectedSubmodals = window.G_vue_instance.$data.selectedSubModals;
        var currentPosition = selectedSubmodals.length - 1;

        if (selectedSubmodals.length && currentPosition) {
          var homeParts = ['home', 'about', 'downloads'];

          this.eventSubItemsChange(selectedSubmodals[currentPosition - 1]);
          this.selectSubpage(selectedSubmodals[currentPosition - 1][0]);
          if (homeParts.includes(selectedSubmodals[currentPosition - 1][0])) {
            this.$router.push(`/${selectedSubmodals[currentPosition - 1][0]}~`);
          }
          window.G_vue_instance.$data.selectedSubModals.pop();
        } else if (this.$route.fullPath === '/dashboard' && currentPosition) {
          this.$router.push(`/${selectedSubmodals[currentPosition - 1][0]}~`);
          window.G_vue_instance.$data.selectedSubModals.pop();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(function () {
      if (this.overrideAuthCallbacks !== true) {
        window.G_firebase_auth.bi5SetSitePageCallbacks(
          this.signingInFeedback,
          this.signedInFeedback,
          this.signInFailedFeedback
        );
      }
      this.waitWatchdogReady();
      this.restoresubModals();
    });
  }
};

var SubpageTemplate = {
  data() {
    return {
      isInitiailized: false,
      params: {},
      subItemsLoaded: false,
      activeModal: "default"
    }
  },
  props: ['subItemIndex', 'subItemsList', 'parentParams'],
  mounted() {
    this.$nextTick(function () {
      this.params = this.parentParams;
      this.waitWatchdogReady();
      this.restoresubModals();
    });
  },
  methods: {
    eventCloseModal() {
      this.showModal(this.defaultModal);
    },
    eventSubItemsLoaded() {
      this.subItemsLoaded = true;
      this.$emit('event-sub-items-loaded', true);
    },
    eventSubItemsChange(new_sub_items_list) {
      if (new_sub_items_list === null || new_sub_items_list === undefined) {
        return;
      }
      this.subItemsList = new_sub_items_list;
      this.$emit('event-sub-items-change', new_sub_items_list);
    },
    eventParamsChange(new_params) {
      this.params = new_params;
      this.$emit('event-parameter-change', this.params);
    },
    restoresubModals() {
      if (this.subItemsList.length > this.subItemIndex) {
        this.showModal(this.subItemsList[this.subItemIndex]);
      } else {
        this.showModal(this.defaultModal);
      }
      if (this.subItemsList.length === this.subItemIndex + 1) {
        this.eventSubItemsLoaded()
      }
    },
    showModal(modalId) {
      this.activeModal = modalId;
      var new_sub_items_list = this.subItemsList;
      if (this.subItemsList.length < this.subItemIndex + 1) {
        new_sub_items_list.push(modalId);
      } else {
        new_sub_items_list[this.subItemIndex] = modalId;
      }
      
      //keep modal close requests from getting into the browswer URL history
      if (new_sub_items_list[new_sub_items_list.length -1] === 'close_modal') {
        new_sub_items_list.pop();
      }
      
      this.eventSubItemsChange(new_sub_items_list);
    },
    updateParams() {
      this.$emit('event-parameter-change', this.params);
    },
    waitWatchdogReady() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (window.G_vue_instance.$data.webGui.watchdogDbConnected === true) {
        this.isInitiailized = true;
        if (this.waitWatchdogReadyCallback) {
          this.waitWatchdogReadyCallback();
        }
      } else {
        setTimeout(this.waitWatchdogReady, 200);
      }
    },
    parseRouteParams(param_list) {
      //this checks if the prop name is in the route params and then calls the functions in the dictionary using the value associated with the prop name in the router params.
      for (var index in param_list) {
        if (param_list[index].prop_name in this.$route.params) {
          for (var index2 in param_list[index].functions)
            param_list[index].functions[index2](this.$route.params[param_list[index].prop_name]);
        }
      }
    },
  },
  watch: {
    '$root.backForwardUrlRequest': {
      handler() {
        this.restoresubModals();
      },
      deep: true
    }
  }
}


var modalTemplate = {
  data() {
    return {
      isInitiailized: false,
      params: {},
      subItemsLoaded: false,
      activeModal: "default",
      actualModalTitle: ''
    }
  },
  props: ['subItemIndex', 'subItemsList', 'parentTitle', 'isModal', 'disableUrlHistory', 'parentParams'],
  mounted() {
    this.$nextTick(function () {
      this.params = this.parentParams;
      this.setModalTitle();
      this.waitWatchdogReady();
      this.restoresubModals();
    });
  },
  watch: {
    subItemsList() {
      if (this.subItemsList[this.subItemIndex] === 'close_modal') {
        this.selfClose();
        return;
      }
      if (
        typeof this.subItemsList[this.subItemIndex] === 'string' &&
        this.activeModal !== this.subItemsList[this.subItemIndex]
      ) {
        this.showModal(this.subItemsList[this.subItemIndex])
      }
    }
  },
  methods: {
    eventCloseChildModals(selectedModal) {
      if (this.actualModalTitle.trim() !== selectedModal.trim()) {
        this.$emit("event-close-child-modals", selectedModal);
        this.$emit("event-child-modal-closed");;
        this.selfClose();
      }
    },
    selfClose() {
      if (!this.disableUrlHistory) {
        var new_sub_items_list = this.subItemsList;
        while (new_sub_items_list.length > this.subItemIndex) {
          new_sub_items_list.pop()
        }
        this.eventSubItemsChange(new_sub_items_list);
      }
      
      this.$emit("event-close-modal");
    },
    eventCloseModal() {
      this.showModal(this.defaultModal);
    },
    eventSubItemsLoaded() {
      this.subItemsLoaded = true;
      this.$emit('event-sub-items-loaded', true);
    },
    eventSubItemsChange(new_sub_items_list) {
      if (this.disableUrlHistory || !this.isModal || !new_sub_items_list) {
        return;
      }
      this.subItemsList = new_sub_items_list;
      this.$emit('event-sub-items-change', new_sub_items_list);
    },
    eventParamsChange(new_params) {
      if (this.disableUrlHistory || !new_params) {
        return;
      }
      this.$emit('event-parameter-change', new_params)
    },
    restoresubModals() {
      if (!this.subItemsList || this.subItemIndex === null || this.subItemIndex === undefined) {
        return;
      }
      if (this.subItemsList.length > this.subItemIndex) {
        this.showModal(this.subItemsList[this.subItemIndex]);
      } else {
        this.showModal(this.defaultModal);
      }
      if (this.subItemsList.length === this.subItemIndex + 1) {
        this.eventSubItemsLoaded();
      }
    },
    showModal(modalId) {
      this.activeModal = modalId;
      if (this.disableUrlHistory) {
        return;
      }
      var new_sub_items_list = this.subItemsList;
      if (this.subItemsList && this.subItemsList.length < this.subItemIndex + 1) {
        new_sub_items_list.push(modalId)
      } else {
        new_sub_items_list[this.subItemIndex] = modalId
      }
      
      //keep modal close requests from getting into the browswer URL history
      if(new_sub_items_list[new_sub_items_list.length - 1] === 'close_modal') {
        new_sub_items_list.pop();
      }

      this.eventSubItemsChange(new_sub_items_list);
    },
    setModalTitle() {
      if (this.isModal) {
        this.actualModalTitle = this.modalTitle;
      }
      if (this.parentTitle &&
        typeof this.parentTitle === 'string' &&
        this.parentTitle.length > 0 &&
        this.modalTitle &&
        typeof this.modalTitle === 'string' &&
        this.modalTitle.length > 0
      ) {
        this.modalTitle = this.parentTitle + ' > ' + this.modalTitle;
      }
    },
    updateParams() {
      this.$emit('event-parameter-change', this.params);
    },
    waitWatchdogReady() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (window.G_vue_instance.$data.webGui.watchdogDbConnected) {
        this.isInitiailized = true;
        if (this.waitWatchdogReadyCallback) {
          this.waitWatchdogReadyCallback();
        }
      } else {
        setTimeout(this.waitWatchdogReady, 200);
      }
    },
    parseRouteParams(param_list) {
      //this checks if the prop name is in the route params and then calls the functions in the dictionary using the value associated with the prop name in the router params.
      for (var index in param_list) {
        if (param_list[index].prop_name in this.$route.params) {
          for (var index2 in param_list[index].functions)
            param_list[index].functions[index2](this.$route.params[param_list[index].prop_name]);
        }
      }
    },
  }
}

var orgPermissionsCheck = {
  data() {
    return {
      userHasOrgEditPermissions: false,
      userHasSystemEditPermissions: false,
      userHasPermissionsFlag: false,
      userPermissionsObject: null,
      userPermissions: '',
    }
  },
  watch: {
    userPermissionsObject: {
      handler() {
        this.bi10UpdateUserPermissions();
      },
      deep: true
    }
  },
  methods: {
    bi10GetOrgPermissions(org_uid,attempt_count) {
      if (window.G_vue_instance.$data.webGui.watchdogDbConnected === false ||
        typeof (org_uid) !== 'string' ||
        org_uid in window.G_web_gui_data.IV_org_permissions === false ||
        'permissions' in window.G_web_gui_data.IV_org_permissions[org_uid] === false
      ) {
        if(attempt_count === undefined || attempt_count === null) { attempt_count = 0; }
        attempt_count += 1;
        //only retry for 30 seconds
        if (attempt_count > 150) { return; }
        setTimeout(function () { this.bi10GetOrgPermissions(org_uid,attempt_count); }.bind(this), 200);
        return;
      }

      this.userPermissionsObject = window.G_web_gui_data.IV_org_permissions[org_uid];
      this.userHasPermissionsFlag = true;
      this.bi10UpdateUserPermissions();
    },

    bi10UpdateUserPermissions() {
      this.userPermissions = this.userPermissionsObject['permissions'];
      var org_edit_permissions = 'adefijkn';

      var user_has_org_edit_permissions = false;
      for (var index in org_edit_permissions) {
        if (this.userPermissions.includes(org_edit_permissions[index])) {
          user_has_org_edit_permissions = true;
          break;
        }
      }
      this.userHasOrgEditPermissions = user_has_org_edit_permissions;

      var user_has_system_edit_permissions = false;
      var system_edit_permisions = 'aopqgh';
      for (var index in system_edit_permisions) {
        if (this.userPermissions.includes(system_edit_permisions[index])) {
          user_has_system_edit_permissions = true;
          break;
        }
      }
      this.userHasSystemEditPermissions = user_has_system_edit_permissions;
    }
  }
}

class getSortingNames {
  static objectName(object_uid) {
    if(object_uid in window.G_web_gui_data.IV_objects_meta_data === false) {
      window.G_web_gui_data.initObjectMetaDataListener(object_uid);
    }
    if(window.G_web_gui_data.IV_objects_meta_data[object_uid] && 
      'name' in window.G_web_gui_data.IV_objects_meta_data[object_uid]
      ) {
      return window.G_web_gui_data.IV_objects_meta_data[object_uid]['name']
    } else {
      return null;
    }
  }

  static objectAttributeName(object_attribute_uid) {
    if(object_attribute_uid in window.G_web_gui_data.IV_object_attributes_meta_data === false) {
      window.G_web_gui_data.initObjectAttributeMetaDataListener(object_attribute_uid);
    }
    if(window.G_web_gui_data.IV_object_attributes_meta_data[object_attribute_uid] && 
      'name' in window.G_web_gui_data.IV_object_attributes_meta_data[object_attribute_uid]
      ) {
      return window.G_web_gui_data.IV_object_attributes_meta_data[object_attribute_uid]['name']
    } else {
      return null;
    }
  }

  static orgName(org_uid) {
    if(org_uid in window.G_web_gui_data.IV_org_meta_data === false) {
      window.G_web_gui_data.initOrgMetaDataListener(org_uid);
    }
    if(window.G_web_gui_data.IV_org_meta_data[org_uid] &&
      'name' in window.G_web_gui_data.IV_org_meta_data[org_uid]
      ) {
      return window.G_web_gui_data.IV_org_meta_data[org_uid]['name']
    } else {
      return null;
    }
  }
}

var BooleanUtils = {
  methods: {
    isTrue(val) {
      return (val === true || val === "true" || val === 1)
    },
    isFalse(val) {
      return (val === false || val === "false" || val === 0)
    },
    isNotFalse(val) {
      return (val !== false && val !== "false" && val !== 0)
    },
    isNotTrue(val) {
      return (val !== true && val !== "true" && val !== 1)
    }
  }
}

var GridComponent = {
  props: ['P_disabled', 'P_editing', 'P_visible', 'P_activeState', 'P_customClass', 'P_customCss'],
  data() {
    return { 
      DV_componentType: 'style'
    }
  },
  computed: {
    C_isVisible() {
      const CI = this;
      if (CI.P_editing === true) {return true}
      return CI.isNotFalse(CI.P_visible);
    },
    C_isActiveState() {
      const CI = this;

      if (typeof CI.P_activeState === "object") {
        return CI.isTrue(CI.P_activeState.val)
      }

      return CI.isTrue(CI.P_activeState);
    },
  },
  methods: {
    eventMouseDown(buttonId, eventType, systemShutdown = false) {
      const CI = this;
      if (eventType === "multiple") {
        CI.$emit('event-mouse-down', buttonId, systemShutdown)
      }
    },
    eventMouseRelease(buttonId, eventType, systemShutdown = false) {
      const CI = this;
      if (eventType === "multiple") {
        CI.$emit('event-mouse-release', buttonId, systemShutdown)
      }
    },
    eventMouseClick(buttonId, eventType, systemShutdown = false) {
      const CI = this;
      if (eventType === "single") {
        CI.$emit('event-mouse-click', buttonId, systemShutdown)
      }
    },
  }
}

export {
  PageTemplate as bi10PageTemplate,
  SubpageTemplate as bi10SubpageTemplate,
  modalTemplate as bi10ModalTemplate,
  orgPermissionsCheck as bi10OrgPermissions,
  getSortingNames as bi10GetSortingNames,
  BooleanUtils as bi10BooleanUtils,
  GridComponent as bi10GridComponent
}


// WEBPACK FOOTER //
// ./src/watchdog_includes/base_i10_UI_mixins.js